import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Icon } from '@iconify/react';

export default function AccessLevelsList({ accessLevels, gates, timetables, onLoad, onDelete }) {
  const gateNameFor = (gateKey) => {
    const gate = gates.find((g) => g.id === gateKey);
    return gate ? gate.name || 'Unnamed gate' : 'Unknown gate';
  };

  const timetableNameFor = (timetableId) => {
    const tt = timetables.find((t) => t.id === timetableId);
    return tt ? tt.name : 'Unknown timetable';
  };

  return (
    <Card>
      <CardHeader
        title="Saved Access Levels"
        subheader={
          accessLevels.length > 0
            ? `${accessLevels.length} access level(s) configured`
            : 'Save a gate/timetable combo to see it here'
        }
      />
      <Box sx={{ p: 2 }}>
        {accessLevels.length === 0 ? (
          <Box
            sx={{
              p: 3,
              textAlign: 'center',
              border: '1px dashed',
              borderColor: 'divider',
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              No access levels saved yet.
            </Typography>
          </Box>
        ) : (
          <Stack spacing={2}>
            {accessLevels.map((al) => (
              <Card key={al.id} variant="outlined" sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
                      {al.name}
                    </Typography>
                    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
                      {al.combos.map((combo) => (
                        <Chip
                          key={combo.id}
                          size="small"
                          variant="outlined"
                          label={`${gateNameFor(combo.gateKey)} → ${timetableNameFor(combo.timetableId)}`}
                        />
                      ))}
                    </Stack>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => onLoad(al)}
                      startIcon={<Icon icon="mdi:pencil-outline" width={16} />}
                    >
                      Load
                    </Button>
                    <Button size="small" color="error" onClick={() => onDelete(al.id)}>
                      <Icon icon="mdi:delete" width={20} />
                    </Button>
                  </Box>
                </Box>
              </Card>
            ))}
          </Stack>
        )}
      </Box>
    </Card>
  );
}
